<template>
  <div class="row justify-content-md-center">
    <div class="col-xl-6 col-lg-6">
      <div class="card card-body bg-light border-0 text-center">
        <h1>Ny abonnent?</h1>
        <p class="text-center">
          Få de ferskeste naturfarevarslene på e-post eller SMS for steder du
          selv velger. Kom i gang med en rask og enkel registrering.
        </p>
        <p class="terms">
          Ved å registrere meg aksepterer jeg
          <a href="#" onclick="event.preventDefault()" v-b-modal.modal-terms
            >vilkårene for bruk av tjenesten</a
          >
          og
          <a href="#" onclick="event.preventDefault()" v-b-modal.modal-privacy
            >personvernerklæring</a
          >
        </p>
        <br />
        <div class="text-center">
          <button
            class="btn btn-nve btn-success btn-lg"
            type="submit"
            @click="signUp()"
          >
            Registrer meg!
          </button>
        </div>
        <p class="areg">
          Har du allerede en bruker?
          <span to="/Varsler" class="mt-3 abtn terms">
            <a onclick="event.preventDefault()" @click="signIn()">Logg inn</a>
          </span>
        </p>
      </div>     
    </div>

    <b-modal
      id="modal-terms"
      ref="modal-terms"
      :hide-header="true"
      :hide-footer="true"
    >
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="$refs['modal-terms'].hide()"
      >
        <span aria-hidden="true">
          <img src="../assets/icons/close.svg" alt="Lukk bruksvilkår" />
        </span>
      </button>
      <div>
        <h1>Vilkår for bruk av tjenesten</h1>
        <p>
          Varslene er et hjelpemiddel og ikke en fasit. Lokale forhold kan være
          annerledes enn det som er varslet regionalt.
        </p>
        <ul>
          <li>
            <a href="{varsomUrl()}" target="_blank"
              >Les om flom-, jordskred- og snøskredvarsel</a
            >
          </li>
          <li>
            <a
              href="{metUrl()}"
              target="_blank"
              >Les om farevarsel fra Meteorologisk institutt</a
            >
          </li>
        </ul>
        <p>
          NVE kan ikke holdes ansvarlig for tekniske problemer knyttet til
          leveranse av e-post og SMS. Du finner alltid oppdaterte varsler på
          varsom.no.
        </p>
        <p>
          Abonnenten er selv ansvarlig for å holde kontaktinformasjonen
          oppdatert.
        </p>
        <p>
          E-postadresse og telefonnummer vil bli benyttet til å sende deg de
          varsler du abonnerer på og for å analysere brukerbehov. NVE vil ikke
          dele informasjon du har registrert med andre.
        </p>
        <p>Tjenesten er gratis.</p>
        <b-button
          class="mx-auto d-block btn-main"
          @click="$refs['modal-terms'].hide()"
          >Lukk</b-button
        >
      </div>
    </b-modal>

    <b-modal
      id="modal-privacy"
      :hide-footer="true"
      :hide-header="true"
      ref="modal-privacy"
    >
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="$refs['modal-privacy'].hide()"
      >
        <span aria-hidden="true">
          <img
            src="../assets/icons/close.svg"
            alt="Lukk personvernerklæringen"
          />
        </span>
      </button>
      <div>
        <h1>Personvernerklæring</h1>
        <Info />
        <b-button
          class="mx-auto d-block btn-main"
          @click="$refs['modal-privacy'].hide()"
          >Lukk</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import Info from "../shared/Personvern";

export default {
  name: "Welcome",
  components: {
    Info,
  },
  data() {
    return {
      errors: "",
      username: "",
      password: "",
    };
  },
  computed: {
    loggedIn() {
      return this.$store.getters.userLoggedIn;
    },
    varsomUrl() {
      return this.$store.getters.varsomUrl;
    },
    metUrl() {
      return this.$store.getters.metUrl;
    }
  },
  methods: {
    async signUp() {
      await this.$store.dispatch("auth/signup");
    },
    async signIn() {
      await this.$store.dispatch("auth/login");
    },
    async signOut() {
      await this.$store.dispatch("auth/logout");
    },
  },
};
</script>
<style lang="scss" scoped>
.card {
  padding: 25px 40px 40px 40px;
  max-width: 404px;
}
router-link {
  text-decoration: none;
}
.abtn {
  border-bottom: none;
  text-decoration: none;
  &:hover,
  &:focus,
  &:active {
    background: inherit;
    border-bottom: none;
  }
  & > a {
    font-size: 16px;
  }
}
.btn-main {
  background: #044962;
  border-radius: 4px;
}
.modal-body > div {
  padding: 48px;
  & > h1 {
    text-align: center;
    padding-bottom: 16px;
  }
}
.terms {
  font-size: 16px;
  & > a {
    font-size: 16px;
  }
}
.areg {
  padding-top: 12px;
  font-size: 16px;
  & > a {
    font-size: 16px;
  }
}
div > h1:first-of-type {
  margin-bottom: 12px;
}
</style>
